import { useNavigate } from "react-router-dom";
import { Button } from "@songtradr/design-language";
import { EmailIcon, Props, routes, text } from "./EmailPasswordButton.Parts";

export const EmailPasswordButton = ({ onClick }: Props) => {
  const navigate = useNavigate();

  return (
    <Button
      $variant="basic"
      type="submit"
      onClick={() => (onClick ? onClick() : navigate(routes.signIn))}
      aria-label={text.email}
    >
      <EmailIcon />
      {text.email}
    </Button>
  );
};
